export const GA_MEASUREMENT_ID = "G-QNB03DH4LN";

const PAGE_TITLES = {
  "/": "TeamKitty | Sports team payments and kitty tracking",
  "/login": "Login | TeamKitty",
  "/register": "Register | TeamKitty",
  "/confirm": "Confirm Registration | TeamKitty",
  "/terms": "Terms | TeamKitty",
  "/privacy": "Privacy | TeamKitty",
  "/cookies": "Cookies | TeamKitty",
  "/delete-account": "Account | TeamKitty",
  "/player": "My Card | TeamKitty",
  "/topup": "Top Up | TeamKitty",
  "/success": "Top-up Complete | TeamKitty",
  "/noticeboard": "Noticeboard | TeamKitty",
  "/collections": "Collections | TeamKitty",
  "/admin": "Admin Dashboard | TeamKitty",
  "/leaderboard": "Leaderboard | TeamKitty",
  "/superadmin": "Super Admin | TeamKitty"
};

const getPageTitle = (pathname) => PAGE_TITLES[pathname] || "TeamKitty";

const canTrack = () =>
  typeof window !== "undefined" &&
  typeof window.gtag === "function";

export function trackPageView(pathname, search = "") {
  const pageTitle = getPageTitle(pathname);
  document.title = pageTitle;

  if (!canTrack()) return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: `${pathname}${search}`,
    page_title: pageTitle,
    send_page_view: true
  });
}

export function trackEvent(eventName, params = {}) {
  if (!canTrack()) return;

  window.gtag("event", eventName, {
    app_name: "teamkitty",
    ...params
  });
}
